import { Route, Routes,Navigate  } from "react-router-dom";
import Login from '../components/Login'
import Signup from "../components/Signup";
import DoctorDashboard from '../components/DoctorDashboard'
import PatientInformation from '../components/PatientInformation'
import Consulting from '../components/Consulting'
import PatientDashoard from '../components/PatientDashoard'
import PrivateRoute from './PrivateRoute'
import DoctorProfile from "../components/DoctorProfile";
import Home from "../components/Home";
import About from "../components/About";
import Contact from "../components/Contact";
export default function Router() {
    // const navigate = useNavigate
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            {/* <Route element={<PrivateRoute />}> */}
            <Route path="doctor-dashboard/profile" element={<PrivateRoute Component={DoctorProfile}/>} />
                <Route path="/doctor-dashboard" element={<PrivateRoute Component={DoctorDashboard} />} />
                <Route path="patient-information/:id" element={<PrivateRoute Component={PatientInformation} />} />
                <Route path="patient/consulting" element={<PrivateRoute Component={Consulting} />} />
                <Route path="patient-dashboard" element={<PrivateRoute Component={PatientDashoard} />} />
            {/* </Route> */}
        </Routes>
    )
}